export class AffichageSitProModel {

    /**
     * Determine l'affichage de la question 1 : 
     * "Vous êtes actuellement" ---> Banéficiaire du RSA / Etudiant non boursier / Etudiant boursier / Dans une autre situation
     */
    isQuestionSituation = false;

    /**
     * Determine l'affichage de la question 2 : 
     * "Vous exercez toujours une activité professionnelle"
     */
    isQuestionProfessionnelle = false;

    /**
     * Determine l'affichage de la question 2.1 : 
     * "Vous êtes au chômage depuis plus de 2 mois" 
     */
    isQuestionChomage = false;

    /**
     * Determine l'affichage de la question 3 : 
     * "Vous êtes toujours indemnisé en {mois - 1}"
     */
    isQuestionIndemnise = false;
}
